import { render, staticRenderFns } from "./multimedia-grand-challenge.vue?vue&type=template&id=696cd048&scoped=true&"
import script from "./multimedia-grand-challenge.vue?vue&type=script&lang=js&"
export * from "./multimedia-grand-challenge.vue?vue&type=script&lang=js&"
import style0 from "./multimedia-grand-challenge.vue?vue&type=style&index=0&id=696cd048&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "696cd048",
  null
  
)

export default component.exports